import { orderServiceListQuery, orderServiceCountQuery } from "./orderService";
import { optionsTemplate } from "./util";

const model = "programs";

export const useProgramList = orderServiceListQuery({ model, defaults: { _limit: 250 } });

const selectOptions = optionsTemplate(
  {
    value: "id",
    label: (program) => `${program.name} (${program.code})`,
    code: "code",
  },
  { sortBy: "code" }
);

export const useProgramOptions = () =>
  useProgramList({ _joins: false, _limit: -1 }, { select: selectOptions });

export const useProgramCount = orderServiceCountQuery({ model });
